import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { ConfigService } from '../../servicios/config/config.service';
import {KeyService} from '../../servicios/key.service';
@Injectable()

export class TercerosService {

  public terceros:any[]=[];
  PATH      = new ConfigService().obtenerPath();
  _key      = new KeyService();
  dataArray = [];

  constructor( private http:Http ) {}

  /**
   * lista terceros 
   * @param string Cliente, Proveedor, Empleado
   * CAAA-2018-04-24
   */
  getListTerceros(tipo)
  {
    let url = this.PATH + '/api/public/list-terceros/'+ tipo;
    return this.http.get(url, {headers: this._key.head()}).map(resp => resp.json());
  }// .getListTerceros(tipo)

  /**
   * lista terceros filtro
   * @param string Cliente, Proveedor, Empleado
   * CAAA-2018-04-24
   */
   listTercerosFiltro(tipo)
    {
      let url = this.PATH + '/api/public/listTercerosFiltro/'+ tipo;
      return this.http.get(url, {headers: this._key.head()}).map(resp => resp.json());
    }// .getListTerceros(tipo)

  /**
   * lista tecnicos tabla segur 
   * CAAA-2018-09-10
   */
  getTecnicos()
  {
    let url = this.PATH + '/api/public/list-tecnico';
    return this.http.get(url, {headers: this._key.head()}).map(resp => resp.json());

  }// .getTecnicos(tipo)

    /**
   * lista tecnicos tabla tercero 
   * CAAA-2018-09-10
   */
  getTecnicosTercero(permiso_vertodaslasincidencias)
  {
    let url = this.PATH + '/api/public/listTecnicosTercero/'+permiso_vertodaslasincidencias;
    return this.http.get(url, {headers: this._key.head()}).map(resp => resp.json());

  }// .getTecnicos(tipo)
  /**
   * Listar tecnicos por coordinador
   * JMM-2018-07-26
   * @param string Coordinador
   */
  getTecnicoCoordinador(coordinadorid)
  {
    let url = this.PATH + '/api/public/list-tecnicocoordinador/'+coordinadorid;
    return this.http.get(url, {headers: this._key.head()}).map(resp=>resp.json());
  }// .getTecnicoCoordinador(coordinadorid)


  buscartercero(terceroid)
  {
    let url = this.PATH + '/api/public/buscar-tercero/'+terceroid;
    return this.http.get(url, {headers: this._key.head()}).map(resp=>resp.json());
  }

  

}



// WEBPACK FOOTER //
// E:/xampp/htdocs/liberado/CocoraSMFront/src/app/servicios/terceros/terceros.service.ts